import { render, staticRenderFns } from "./SecondCategoryManage.vue?vue&type=template&id=aa4f81d6&scoped=true"
import script from "./SecondCategoryManage.vue?vue&type=script&lang=js"
export * from "./SecondCategoryManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4f81d6",
  null
  
)

export default component.exports